var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GEMINI_SUMMARY_I18N, GEMINI_SUMMARY_PENDING_VALUE, GeminiSummaryMetricLine, GeminiSummarySlashPair, GeminiSummarySubLabel, GeminiSummaryVsSeparator } from '@web/components/Apps/Gemini/geminiSummaryCards';
import { GeminiSummaryUsageLevelMetric } from '@web/components/Apps/Gemini/geminiUsageLevel';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { SummaryCardLabel, SummaryCardShell } from '@web/components/layout/SummaryCards/SummaryCards';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { GEMINI_USAGE_LEVEL_COLORS_CONFIG } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { GeminiUsageLevelEnum, InsightTypeEnum } from '@workalizer/shared';
import { GEMINI_USAGE_LEVEL_RANK } from '@workalizer/shared/lib/gemini-usage-level';
import { getPercentageDiff } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
var I18N = GEMINI_SUMMARY_I18N;
var USAGE_LEVEL_CARDS = [
    [GeminiUsageLevelEnum.ZERO, GeminiUsageLevelEnum.LOW],
    [GeminiUsageLevelEnum.MEDIUM, GeminiUsageLevelEnum.HIGH]
];
var buildCsvRows = function (data, t) {
    var _a, _b, _c, _d, _e;
    var metric = t("".concat(I18N, ".export.metric"));
    var value = t("".concat(I18N, ".export.value"));
    var diff = t("".concat(I18N, ".export.diff"));
    return [
        (_a = {},
            _a[metric] = t("".concat(I18N, ".adoptionRate")),
            _a[value] = "".concat(data.adoptionRate.count, " / ").concat(data.adoptionRate.share, "%"),
            _a[diff] = data.adoptionRate.previous.diffString,
            _a),
        (_b = {},
            _b[metric] = t("".concat(I18N, ".avgActionsPerUser")),
            _b[value] = data.avgActionsPerUser.count,
            _b[diff] = data.avgActionsPerUser.previous.diffString,
            _b),
        (_c = {},
            _c[metric] = t("".concat(I18N, ".geminiInvocations")),
            _c[value] = data.totalActions.count,
            _c[diff] = data.totalActions.previous.diffString,
            _c),
        (_d = {},
            _d[metric] = t("".concat(I18N, ".standalone")),
            _d[value] = "".concat(data.standaloneInAppUsage.left.share, "% / ").concat(data.standaloneInAppUsage.left.count),
            _d[diff] = data.standaloneInAppUsage.left.previous.diffString,
            _d),
        (_e = {},
            _e[metric] = t("".concat(I18N, ".inAppUsage")),
            _e[value] = "".concat(data.standaloneInAppUsage.right.share, "% / ").concat(data.standaloneInAppUsage.right.count),
            _e[diff] = data.standaloneInAppUsage.right.previous.diffString,
            _e)
    ];
};
function GeminiTeamSummary() {
    var _this = this;
    var t = useTranslation().t;
    var _a = useFilters(), dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnit = _a.orgUnit;
    var _b = trpc.geminiSummary.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        orgUnitId: orgUnit
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var usageLevelPeriodValid = data.usageLevel.period.isValid;
    var _c = data.usageLevel, usageLevel = _c.level, previousLevel = _c.previousLevel;
    var usageLevelPreviousComparable = usageLevelPeriodValid && previousLevel !== null;
    var usageLevelPrevDiff = usageLevelPeriodValid && previousLevel !== null && usageLevel
        ? getPercentageDiff(GEMINI_USAGE_LEVEL_RANK[previousLevel], GEMINI_USAGE_LEVEL_RANK[usageLevel])
        : undefined;
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t("".concat(I18N, ".title")), description: "widgetTitleDescriptions.apps.geminiSummary", insightType: InsightTypeEnum.geminiSummary, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t("".concat(I18N, ".title")), onExportHandler: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, buildCsvRows(data, t)];
                    }); }); }, disabled: isAiButtonDisabled(data) }) }), _jsxs("div", __assign({ className: "grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-5" }, { children: [_jsxs(SummaryCardShell, __assign({ className: "flex h-full flex-col" }, { children: [_jsx(SummaryCardLabel, __assign({ tooltip: t("".concat(I18N, ".usageLevelAdoptionRateTooltip")) }, { children: t("".concat(I18N, ".usageLevel")) })), _jsx(GeminiSummaryUsageLevelMetric, { level: data.usageLevel.level, isPeriodValid: usageLevelPeriodValid, prevPeriodDiff: usageLevelPrevDiff, t: t }), _jsx(GeminiSummarySubLabel, __assign({ className: "mt-auto pt-2.5" }, { children: t("".concat(I18N, ".adoptionRate")) })), _jsx(GeminiSummarySlashPair, { left: {
                                    value: String(data.adoptionRate.count),
                                    prevPeriodDiff: data.adoptionRate.previous
                                }, right: { value: "".concat(data.adoptionRate.share, "%") } })] })), USAGE_LEVEL_CARDS.map(function (levels) { return (_jsxs(SummaryCardShell, __assign({ className: "flex h-full flex-col" }, { children: [_jsx(SummaryCardLabel, __assign({ tooltip: t("".concat(I18N, ".usageLevelTooltip")) }, { children: t("".concat(I18N, ".usageLevel")) })), levels.map(function (level, index) {
                                var _a = GEMINI_USAGE_LEVEL_COLORS_CONFIG[level], color = _a.color, translationKey = _a.translationKey;
                                var levelData = data.usageLevel.distribution[level];
                                return (_jsxs("div", __assign({ className: index > 0 ? 'mt-auto pt-2' : 'mt-1.5' }, { children: [_jsx(GeminiSummarySubLabel, __assign({ swatchClassName: color }, { children: t("".concat(I18N, ".usageLevels.").concat(translationKey)) })), _jsx(GeminiSummarySlashPair, { left: {
                                                value: usageLevelPeriodValid
                                                    ? String(levelData.count)
                                                    : GEMINI_SUMMARY_PENDING_VALUE,
                                                prevPeriodDiff: usageLevelPreviousComparable
                                                    ? levelData.previous
                                                    : undefined
                                            }, right: {
                                                value: usageLevelPeriodValid
                                                    ? "".concat(levelData.share, "%")
                                                    : GEMINI_SUMMARY_PENDING_VALUE
                                            } })] }), level));
                            })] }), levels.join('-'))); }), _jsxs(SummaryCardShell, __assign({ className: "flex h-full flex-col" }, { children: [_jsx(SummaryCardLabel, __assign({ tooltip: t("".concat(I18N, ".avgActionsPerUserTooltip")) }, { children: t("".concat(I18N, ".avgActionsPerUser")) })), _jsx(GeminiSummaryMetricLine, { value: String(data.avgActionsPerUser.count), prevPeriodDiff: data.avgActionsPerUser.previous }), _jsx(GeminiSummarySubLabel, __assign({ className: "mt-auto pt-2.5" }, { children: t("".concat(I18N, ".geminiInvocations")) })), _jsx(GeminiSummaryMetricLine, { value: String(data.totalActions.count), prevPeriodDiff: data.totalActions.previous })] })), _jsxs(SummaryCardShell, __assign({ className: "flex h-full flex-col" }, { children: [_jsx(SummaryCardLabel, __assign({ tooltip: t("".concat(I18N, ".standaloneInAppUsageTooltip")) }, { children: t("".concat(I18N, ".standalone")) })), _jsx(GeminiSummarySlashPair, { left: {
                                    value: "".concat(data.standaloneInAppUsage.left.share, "%"),
                                    prevPeriodDiff: data.standaloneInAppUsage.left.previous
                                }, right: { value: String(data.standaloneInAppUsage.left.count) } }), _jsxs("div", __assign({ className: "mt-auto" }, { children: [_jsx(GeminiSummaryVsSeparator, { children: t("".concat(I18N, ".vs")) }), _jsx(GeminiSummarySubLabel, __assign({ className: "mt-1.5" }, { children: t("".concat(I18N, ".inAppUsage")) })), _jsx(GeminiSummarySlashPair, { left: {
                                            value: "".concat(data.standaloneInAppUsage.right.share, "%"),
                                            prevPeriodDiff: data.standaloneInAppUsage.right.previous
                                        }, right: { value: String(data.standaloneInAppUsage.right.count) } })] }))] }))] }))] }));
}
export default GeminiTeamSummary;
